import Vue from 'vue';

export default Vue.directive('animatedIncrementingNumbers', {
  twoWay: true,

  inserted: function (el, binding, vnode){
    vnode.context.userData[binding.value.varName] = binding.value.minValue || 0;

    setTimeout(() => {
      binding.value.interval = window.setInterval(() => {
        if (vnode.context.userData[binding.value.varName] < binding.value.valToAnimateTo){
          var change = (binding.value.valToAnimateTo - vnode.context.userData[binding.value.varName]) / binding.value.changeDiv;
          change = change >= 0 ? Math.ceil(change) : Math.floor(change);
         // vnode.context.userData[binding.value.varName] =Math.min(vnode.context.userData[binding.value.varName] + binding.value.increment, binding.value.valToAnimateTo);
          vnode.context.userData[binding.value.varName] = vnode.context.userData[binding.value.varName] + change;
        }
        else {
          clearInterval(binding.value.interval);
          vnode.context.animationsCompleted++;
        }
      }, binding.value.timeInterval);
    }, 400);
  }
});



// WEBPACK FOOTER //
// ./src/directives/animatedIncrementingNumbers.js